/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useState } from 'react';
import bannerLogo from '../../../assets/images/banner-logo.png';
import heroImg from '../../../assets/images/hero-banner.png';
import { StyledHeroSection } from './HeroSection.styles';

function HeroSection({ noLogo }) {
  const [bannerImg, setBannerImg] = useState(heroImg);
  function handleBannerImg(e) {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = event => {
        setBannerImg(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  }
  return (
    <StyledHeroSection image={bannerImg} $fluid={noLogo}>
      {!noLogo && (
        <div className="logo-holder">
          <img src={bannerLogo} alt="bannerLogo" />
        </div>
      )}
      <button type="button">
        <input type="file" id="bannerImg" accept="image/*" onChange={handleBannerImg} />
        <label htmlFor="bannerImg">
          Edit Business Details <span className="material-icons">edit</span>
        </label>
      </button>
    </StyledHeroSection>
  );
}

export default HeroSection;
